// extracted by mini-css-extract-plugin
export default {"consultationCompleteAttachmentWrapper":"ConsultationCompleteAttachment_consultationCompleteAttachmentWrapper__bAshJ"};